/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kommentarabrechnung1Inputs */

const de__field_kommentarabrechnung1 = /** @type {(inputs: _Field_Kommentarabrechnung1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentar Abrechnung`)
};

/**

* @param {_Field_Kommentarabrechnung1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kommentarabrechnung1 = /** @type {((inputs?: _Field_Kommentarabrechnung1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kommentarabrechnung1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kommentarabrechnung1(inputs)
});
export { _field_kommentarabrechnung1 as "_field_kommentarAbrechnung" }